<gl-pro-modal (closeModal)="close(false)">
  <p>{{ 'slots_empty_message' | translate }}</p>
  <div class="buttons">
    <button outline-button (click)="close(true)">{{ 'add_users' | translate }}</button>
  </div>
</gl-pro-modal>
